import React, { useState } from "react";
import { DoctorTile } from "../../shared";
import { fetchAllDoctorsNearby } from "../../api/getProvider";
import { useEffect } from "react";
import { IDoctor, IDoctorsFull } from "../../interfaces/api";
import { useZipRootLoaderData } from "../../hooks/useZipRootLoaderData";

const optionMiles = [
  { distance: "1" },
  { distance: "5" },
  { distance: "10" },
  { distance: "20" },
  { distance: "30" },
  { distance: "50" },
];

const AllDoctorsDrugs = ({
  handleViewMedicalGroups,
}: {
  handleViewMedicalGroups: (doctor: IDoctor) => void;
}) => {
  const { zip } = useZipRootLoaderData();
  const [acceptNewPatients, setAcceptNewPatients] = useState<boolean>(false);
  const [doctorsData, setDoctorsData] = useState<IDoctorsFull>();
  const [miles, setMiles] = useState<string>("30");

  const sessionYear = sessionStorage.getItem("planYear");

  useEffect(() => {
    async function fetchData() {
      if (zip) {
        const data = await fetchAllDoctorsNearby({
          zipcode: zip,
          miles: miles,
          planyear: sessionYear
            ? sessionYear
            : new Date().getFullYear().toString(),
        });
        data.providers = data.providers.filter((provider: IDoctor) => {
          return !!provider.nppes.firstName;
        });

        setDoctorsData(data);
      }
    }

    fetchData();
  }, [miles, zip]);

  return (
    <>
      <div
        className="hide-for-small-only"
        style={{
          padding: "32px 70px 32px 70px",
          textAlign: "start",
        }}
      >
        <h3 className="color-secondary text-uppercase">All Doctors</h3>
        <img
          src={
            (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
            "/vector.svg"
          }
          alt="Vector"
          style={{ marginRight: "8px" }}
        />
        <div
          className="flex-container align-middle"
          style={{ padding: "24px 0px", display: "flex" }}
        >
          <div style={{ paddingRight: "16px" }}>
            {zip} | {doctorsData?.totalNPICount} results within
          </div>{" "}
          <select
            style={{
              width: "150px",
              padding: "14px 16px",
              cursor: "pointer",
            }}
            onChange={(e) => setMiles(e.target.value)}
            value={miles}
          >
            {optionMiles.map((mile) => (
              <option key={mile.distance} value={mile.distance}>
                {mile.distance} Miles
              </option>
            ))}
          </select>
        </div>
        <div>
          If you don't see your doctor, give us a call.{" "}
          <span className="color-primary text-underline">
            <a href="tel:18882938272">1-888-293-8272</a>
          </span>{" "}
          (TTY: 711).
        </div>
        <div>
          <div style={{ padding: "42px 0px 10px 4px" }}>
            <label
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                fontSize: "18px",
              }}
            >
              <input
                type="checkbox"
                checked={acceptNewPatients}
                onChange={() => setAcceptNewPatients(!acceptNewPatients)}
                style={{ width: 18, height: 18 }}
              />
              <div style={{ paddingLeft: "8px" }}>Accepting new patients</div>
            </label>
          </div>
          <div
            className="grid-x"
            style={{ overflowY: "auto", maxHeight: "400px" }}
          >
            {acceptNewPatients
              ? doctorsData?.providers
                  .filter((doctor) =>
                    doctor.ahRecords.some(
                      (record) =>
                        acceptNewPatients &&
                        record.addresses.some(
                          (address) => address.isAcceptingNewPatients === "Yes"
                        )
                    )
                  )
                  .map((doctor, index) => (
                    <DoctorTile
                      key={index}
                      data={doctor}
                      handleViewMedicalGroups={handleViewMedicalGroups}
                    />
                  ))
              : doctorsData?.providers.map((doctor, index) => (
                  <DoctorTile
                    key={index}
                    data={doctor}
                    handleViewMedicalGroups={handleViewMedicalGroups}
                  />
                ))}
          </div>
        </div>
      </div>
      <div
        className="show-for-small-only"
        style={{
          padding: "20px",
          textAlign: "start",
        }}
      >
        <h3 className="color-secondary text-uppercase">All Doctors</h3>
        <img
          src={
            (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
            "/vector.svg"
          }
          alt="Vector"
          style={{ marginRight: "8px" }}
        />
        <div
          className="flex-container align-middle"
          style={{ padding: "24px 0px", display: "flex" }}
        >
          <div style={{ paddingRight: "16px" }}>
            {zip} | {doctorsData?.totalNPICount} results within
          </div>{" "}
          <select
            style={{
              width: "150px",
              padding: "14px 16px",
              cursor: "pointer",
            }}
            onChange={(e) => setMiles(e.target.value)}
            value={miles}
          >
            {optionMiles.map((mile, index) => (
              <option key={index} value={mile.distance}>
                {mile.distance} Miles
              </option>
            ))}
          </select>
        </div>
        <div>
          If you don't see your doctor, give us a call.{" "}
          <span className="color-primary text-underline">
            <a href="tel:18882938272">1-888-293-8272</a>
          </span>{" "}
          (TTY: 711).
        </div>
        <div>
          <div style={{ padding: "42px 0px 10px 4px" }}>
            <label
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                fontSize: "18px",
              }}
            >
              <input
                type="checkbox"
                checked={acceptNewPatients}
                onChange={() => setAcceptNewPatients(!acceptNewPatients)}
                style={{ width: 18, height: 18 }}
              />
              <div style={{ paddingLeft: "8px" }}>Accepting new patients</div>
            </label>
          </div>
          <div
            className="grid-x"
            style={{ overflowY: "auto", maxHeight: "400px" }}
          >
            {doctorsData?.providers.map((doctor, index) => (
              <DoctorTile
                key={index}
                data={doctor}
                handleViewMedicalGroups={handleViewMedicalGroups}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AllDoctorsDrugs;
